import { render, staticRenderFns } from "./imprDetailHC.vue?vue&type=template&id=0fc116ac"
import script from "./imprDetailHC.vue?vue&type=script&lang=js"
export * from "./imprDetailHC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fc116ac')) {
      api.createRecord('0fc116ac', component.options)
    } else {
      api.reload('0fc116ac', component.options)
    }
    module.hot.accept("./imprDetailHC.vue?vue&type=template&id=0fc116ac", function () {
      api.rerender('0fc116ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/ibm/imprDetailHC.vue"
export default component.exports